import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import syncLocalStorage from './plugins/sync-local-storage'
import app from './modules/app'
import user from './modules/user'
import materiel from './modules/materiel'
import menuChildren from './modules/menuChildren'
import sitesEditor from './modules/sitesEditor'
import book from './modules/book'
import websocket from '@/utils/websocket/store'
import course from './modules/course'
import permission from './modules/permission'

import system from './modules/system'
// dynamic router permission control (Experimental)
// default router permission control
// import permission from './modules/async-router'
import getters from './getters'

import timChat from '@/utils/chat/tim/store/index'
import plvPPTPlayer from '@/utils/plvPPTPlayer/store/index'
const persistedState = createPersistedState({
  storage: window.localStorage,
  paths: ['user.userInfo', 'user.token', 'user.isAudition', 'system.orgInfo', 'system.breadcrumbList']
})
Vue.use(Vuex)
export default new Vuex.Store({
  modules: {
    app,
    permission,
    materiel,
    menuChildren,
    sitesEditor,
    book,
    websocket,
    course,
    timChat,
    plvPPTPlayer,
    user,
    system
  },
  state: {},
  mutations: {},
  actions: {},
  getters,
  plugins: [
    syncLocalStorage,
    persistedState
  ],
  // strict: process.env.NODE_ENV === 'development',
})
